/**
 * @generated SignedSource<<219304acea47254d44b647c6be7186db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ProfileSettingsForm_notificationCycles",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsForm_notificationCycles"
    }
  ],
  "type": "NotificationCycle",
  "abstractKey": null
};

node.hash = "9fb6f36c3701b963bec5706e73792811";

module.exports = node;
